import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { PublicInterestRepository } from "@entity/data/repositories/public-interest.repository";
import { CreatePublicInterest } from "@entity/domain/models/public-interest/create-public-interest.model";
import { PublicInterest } from "@entity/domain/models/public-interest/public-interest.model";
import { inject, injectable } from "inversify";

@injectable()
export class CreatePublicInterestUseCase {
    constructor(
        @inject(PublicInterestRepository)
        private readonly publicInterestRepository: PublicInterestRepository,
    ) {}

    async execute(
        publicInterest: CreatePublicInterest,
    ): Promise<Nullable<PublicInterest>> {
        const creationResult =
            await this.publicInterestRepository.create(publicInterest);

        if (creationResult.isLeft()) {
            ToastManagerStore.error(creationResult.getLeftOrThrow().message);
        }

        return creationResult.fold(
            () => null,
            (createdPublicInterest) => createdPublicInterest,
        );
    }
}
